export const styles: { [key: string]: React.CSSProperties } = {
  welcomeScreen: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "40px",
    color: "white",
    gap: "100px",
    width: "100%",
    height: "100%",
    zIndex: 10,
  },
  welcomeScreenActions: {
    display: "flex",
    flexDirection: "column",
    gap: "50px",
  },
};
